<template>
  <div class="page-statistics-signin">
    <crm-panel :title="'签到统计'">
      <div class="page-buttons">
        <crm-button
          v-if="webStatisticsAuth.signin.export.auth"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isExportDisabled"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item label="签到时间：">
            <el-date-picker
              :clearable="false"
              :editable="false"
              v-model="searchForm.time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              align="right"
              start-placeholder="签到日期始"
              end-placeholder="签到日期止"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-cascader
              clearable
              placeholder="团队"
              :props="{ checkStrictly: true }"
              :options="signinTeamList"
              @change="changeParentTeam"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="searchNameType" slot="prepend">
                <el-option label="用户姓名" :value="1"></el-option>
                <el-option label="用户账号" :value="2"></el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 签到列表 -->
      <el-table
        :data="signInList.list.results"
        border
        v-loading="loading"
        style="width: 100%;"
        height="100%"
      >
        <!-- fixed -->
        <el-table-column width="120" prop="loginId" label="账号" align="center">
        </el-table-column>
        <el-table-column
          width="120"
          prop="userName"
          align="center"
          label="用户"
        >
        </el-table-column>
        <el-table-column
          width="180"
          show-overflow-tooltip
          prop="tameName"
          align="center"
          label="团队"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in signInList.title"
          :key="index"
          align="center"
          :label="item"
        >
          <template slot-scope="scope">
            <span
              :style="{
                color:
                  (scope.row.record[index] && scope.row.record[index].value) > 0
                    ? 'blue'
                    : '',
              }"
              @click="handleDetailShow(scope.row.record[index], scope)"
            >
              {{ scope.row.record[index] && scope.row.record[index].value }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 签到列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="searchForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="signInList.list.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 签到记录详情弹窗 -->
    <el-dialog
      :title="signInDetail.userName"
      :visible.sync="dialogVisible"
      width="35%"
    >
      <p class="dialog-date">{{ signInDetail.signinDate }}</p>
      <ul class="dialog-list-container">
        <li
          class="dialog-list-item"
          v-for="(item, index) in signInDetail.record"
          :key="index"
        >
          <p>
            <span class="list-item-time">{{
              item.checkinTime | formatTimeShow
            }}</span>
            <span>{{ item.place }}</span>
          </p>
          <p>{{ item.detailPlace }}</p>
          <p>备注：{{ item.remark }}</p>
          <p>拜访对象：{{ item.visitUser }}</p>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <crm-button :text="'确定'" @click="dialogVisible = false"></crm-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import * as utils from '@/scripts/utils';
import config from '~config';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';

export default {
  components: {
    crmPanel,
    crmButton,
  },
  filters: {
    isFinishedMap(val) {
      if (val === 0) {
        return '未完成';
      }
      return '完成';
    },
    formatTimeShow(time) {
      let result = '';
      if (time) {
        time = new Date(time);
        const year = time.getFullYear();
        const month = time.getMonth() + 1 < 10
          ? `0${time.getMonth() + 1}`
          : `${time.getMonth() + 1}`;
        const date = time.getDate() < 10 ? `0${time.getDate()}` : `${time.getDate()}`;
        result = `${year}-${month}-${date}`;
      }
      return result;
    },
  },
  data() {
    return {
      loading: false,
      searchForm: {
        teamId: '',
        time: [
          moment()
            .add(-1, 'days')
            .format('YYYY-MM-DD'),
          moment()
            .add(-1, 'days')
            .format('YYYY-MM-DD'),
        ],
        loginId: '',
        userName: '',
        pageNumber: 1,
        pageSize: 10,
      },
      searchNameType: 1,
      searchName: '',
      dialogVisible: false,
      isExportDisabled: false,
      mounted: false,
    };
  },
  computed: {
    ...mapGetters({
      signInList: 'statistics/signInList',
      webStatisticsAuth: 'authority/webStatisticsAuth',
      signInDetail: 'statistics/signInDetail',
      signinTeams: 'common/signinTeams',
    }),
    signinTeamList() {
      let teamArr = [];
      teamArr = JSON.parse(JSON.stringify([this.signinTeams]));
      this.deleteEmptyChild(teamArr);
      return teamArr;
    },
  },
  watch: {
    'searchForm.teamId': {
      handler: 'handleSearch',
    },
    'searchForm.time': {
      handler: 'handleSearch',
    },
  },
  mounted() {
    this.mounted = true;
    this.getSigninTeams();
    this.getSignInData();
    setTimeout(() => {
      this.mounted = false;
    }, 0);
  },
  methods: {
    ...mapActions({
      getSignInList: 'statistics/getSignInList',
      handleSignInExport: 'statistics/handleSignInExport',
      getSignInDetail: 'statistics/getSignInDetail',
      getSigninTeams: 'common/getSigninTeams',
    }),
    deleteEmptyChild(arr) {
      arr.forEach((item) => {
        if (!item.children || item.children.length <= 0) {
          delete item.children;
        } else {
          this.deleteEmptyChild(item.children);
        }
      });
    },
    changeParentTeam(team) {
      this.searchForm.teamId = team[team.length - 1];
    },
    goVisitRecord() {
      this.$router.push({ name: 'visitRecord' });
    },
    goDataBoard() {
      this.$router.push({ name: 'dataBoard' });
    },
    handleSearch() {
      if (this.mounted) return;
      const prevTime = utils.getLapseDateOfYear(this.searchForm.time[0]);
      const lastTime = utils.getLapseDateOfYear(this.searchForm.time[1]);
      if (lastTime - prevTime > 30) {
        this.$message({
          type: 'error',
          message: '最多可以搜索30天的数据，请重新选择日期！',
        });
      } else {
        this.searchForm.pageNumber = 1;
        this.getSignInData();
      }
    },
    getSignInData() {
      this.searchForm.userName = null;
      this.searchForm.loginId = null;
      this.loading = true;
      Object.keys(this.searchForm).forEach((key) => {
        if (this.searchForm[key] === '') {
          this.searchForm[key] = null;
        }
      });
      if (this.searchName) {
        if (this.searchNameType === 1) {
          this.searchForm.userName = this.searchName;
        } else if (this.searchNameType === 2) {
          this.searchForm.loginId = this.searchName;
        }
      }
      const { time, ...otherParams } = this.searchForm;
      this.getSignInList({
        ...otherParams,
        startTimeStr: this.searchForm.time[0],
        endTimeStr: this.searchForm.time[1],
      }).finally(() => {
        this.loading = false;
      });
    },
    // 导出
    handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在导出中，请稍后...',
        duration: 0,
        showClose: false,
      });
      const prevTime = utils.getLapseDateOfYear(this.searchForm.time[0]);
      const lastTime = utils.getLapseDateOfYear(this.searchForm.time[1]);
      if (lastTime - prevTime > 30) {
        this.$message({
          type: 'error',
          message: '最多可以搜索30天的数据，请重新选择日期！',
        });
      } else {
        const { time, ...otherParams } = this.searchForm;
        const params = {
          ...otherParams,
          startTimeStr: this.searchForm.time[0],
          endTimeStr: this.searchForm.time[1],
        };

        let url = `${config.api || ''}/api/signin/download?`;
        Object.keys(params).forEach((item) => {
          if (params[item]) url += `${item}=${params[item]}&`;
        });

        utils.downloadByUrl(url);
        this.isExportDisabled = false;
        if (this.notify) this.notify.close();
      }
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.searchForm.pageNumber = 1;

      this.getSignInData();
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.searchForm.pageNumber = val;
      this.getSignInData();
    },
    handleDetailShow(record, scope) {
      if (record) {
        this.getSignInDetail({
          dingDingUserId: scope.row.dingDingUserId,
          signinDate: record.key,
          loginId: scope.row.loginId,
        }).then(() => {
          this.dialogVisible = true;
        });
        this.dialogVisible = true;
      }
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';

.page-statistics-signin {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .el-dialog__body {
    border-top: 1px solid #cccccc;
    padding-top: 0;
    .dialog-date {
      font-size: 16px;
      line-height: 30px;
      border-bottom: 1px solid #cccccc;
    }
    .dialog-list-container {
      padding: 0;
      .dialog-list-item {
        padding: 10px 0;
        border-bottom: 1px solid #cccccc;
        line-height: 20px;
        .list-item-time {
          margin-right: 20px;
        }
      }
    }
  }
}
.el-tooltip__popper {
  width: 300px;
}
</style>
